/**
 * Emotes Panel Component
 * Dance emote selection interface
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Sparkles, X } from 'lucide-react';

const EmotesPanel = ({
  isOpen,
  onClose,
  emotes,
  onPlayEmote
}) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-[9990] flex items-center justify-center bg-black/80 p-4"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
      data-testid="emotes-panel-overlay"
    >
      <Card 
        className="w-full max-w-md bg-gray-900 border-yellow-500/30"
        data-testid="emotes-panel"
      >
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle className="text-white flex items-center gap-2">
            <Sparkles className="w-5 h-5 text-yellow-500" />
            Dance Emotes
          </CardTitle>
          <Button variant="ghost" size="icon" onClick={onClose} data-testid="close-emotes">
            <X className="w-5 h-5" />
          </Button>
        </CardHeader>
        <CardContent className="max-h-[60vh] overflow-y-auto">
          <div className="grid grid-cols-5 gap-2">
            {emotes.map(emote => (
              <button
                key={emote.id}
                onClick={() => onPlayEmote(emote)}
                className="p-3 rounded-lg border-2 border-white/20 hover:border-yellow-500/50 hover:bg-yellow-500/10 transition-all flex flex-col items-center gap-1"
                data-testid={`emote-${emote.id}`}
              >
                <span className="text-2xl">{emote.icon}</span>
                <span className="text-[10px] text-white/80">{emote.name}</span>
              </button>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default EmotesPanel;
